import { CascadiaJsonFormContext } from "@certn/forms/src/CascadiaJsonFormContext";
import { ArrayLayoutProps } from "@jsonforms/core";
import { getItemName } from "../../utils";
import { BaseAddItemButton } from "./BaseAddItemButton";
import { useTranslation } from "react-i18next";
import { useContext } from "react";

export function AddItemButton(props: ArrayLayoutProps) {
  const {
    uischema,
    uischema: { options },
    label,
    path,
  } = props;
  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);
  const { t } = useTranslation();

  const itemName = getItemName(uischema, label, t("Field"));
  const maxItems = props.rootSchema.properties?.[itemName]?.maxItems;
  if (
    options?.allowItemAdd === false ||
    isSummaryForPath?.(path) ||
    (maxItems !== undefined && maxItems <= 1)
  ) {
    return <></>;
  }

  return <BaseAddItemButton {...props} />;
}
